import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { ChatDict } from 'src/app/core/model/v2/chat/chat-dict';
import { ChatService } from 'src/app/core/services/v2/chat.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';
import { PhysicianOptionService } from '../shared/physician-option/physician-option.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit {

  chats: ChatDict[] = [];
  currentSelected: ChatDict = new ChatDict();
  currentUserId: number;

  constructor(private physicianOptionService: PhysicianOptionService,
    private chatService: ChatService,
    private loaderService: WindowLoaderService) { }

  ngOnInit() {
    this.physicianOptionService.selectionChange$.subscribe(
      (p) => {
        this.loaderService.show();
        this.currentUserId = p.selectedPhysician.userId;
        this.chatService.getMessagesPerUser(p.selectedPhysician.userId).subscribe(
          (response) => {
            this.chats = response;
            this.loaderService.hide();
          },
          (error) => { console.error(error); this.loaderService.hide(); },
          () => { }
        )
      }
    );
  }

  selectChat(chat: ChatDict): void {
    this.currentSelected = chat;
    this.currentSelected.messages = this.currentSelected.messages.sort((a, b) => moment(a.date).isAfter(moment(b.date)) ? -1 : 1);
  }

}
